import { useEffect } from "react";
import { log } from "@qgiv/core-js";
import {
    getIdOfPaymentIframeContainer,
    getParsedDataFromPostMessage,
    getPaymentIframeResizeEventName,
} from "../../utility";

/**
 *
 * @description This needs to run in CMS as it listens to resize events that
 * change the height of the payment iframe if things like validation errors are
 * displayed.
 * @param {object} props
 * @param {boolean} props.hasLoadedPaymentIframe
 * @param {string} props.originOfPaymentIframe
 * @param {Function} props.setHasLoadedPaymentIframe
 * @returns {null}
 */
const useListenToPaymentIframe = ({
    hasLoadedPaymentIframe,
    originOfPaymentIframe,
    setHasLoadedPaymentIframe,
}) => {
    const idOfPaymentIframeContainer = getIdOfPaymentIframeContainer();
    const paymentIframeResizeEvent = getPaymentIframeResizeEventName();

    /**
     * @description The id of the the containing div is used as any attempts to
     * target the iframe directly result in 3px of additional white space being
     * added in between these two elements.
     * @param {object} parsedData
     * @returns {void}
     */
    const resizePaymentIframe = (parsedData) => {
        const { data } = parsedData;
        const { height } = data;

        log("PAYMENT APP: RECEIVE PAYMENT IFRAME RESIZE");
        log({
            data,
        });

        /** @type {HTMLElement | null} */
        const paymentIframe = document.querySelector(
            `#${idOfPaymentIframeContainer}`,
        );
        const heightInPixels = `${height}px`;

        if (paymentIframe) {
            paymentIframe.style.height = heightInPixels;
        }
    };

    /**
     * @returns {void}
     */
    const replaceLoadingAnimation = () => {
        log("PAYMENT APP: REPLACE LOADING ANIMATION");

        setHasLoadedPaymentIframe(true);
    };

    /**
     * @param {MessageEvent} message
     * @returns {void}
     */
    const handleIncomingPostMessage = (message) => {
        if (message.origin !== originOfPaymentIframe) {
            return;
        }

        const parsedData = getParsedDataFromPostMessage(message);

        if (parsedData.event === paymentIframeResizeEvent) {
            resizePaymentIframe(parsedData);
        }

        if (
            parsedData.event === paymentIframeResizeEvent &&
            !hasLoadedPaymentIframe
        ) {
            replaceLoadingAnimation();
        }

        log("------------------------------------------");
    };

    // Add the listener when the payment iframe is first rendered and remove it
    // whenever the component is dismounted
    useEffect(() => {
        log("---------------------------------------------");
        log("useListenToPaymentIframe()");
        window.addEventListener("message", handleIncomingPostMessage, false);

        return () =>
            window.removeEventListener("message", handleIncomingPostMessage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default useListenToPaymentIframe;
